import http from "./http.service";


export const getTodayCheckins = async (payload: any) => {
    return http.get(`/partner/checkins`, { params: payload });
}

export const confirmCheckin = async (uniqueCode: string) => {
    return http.put(`/partner/checkins/confirm`, null, { params: { uniqueCode } });
}

